<form id="erweiterungen" [formGroup]="formGroup" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off" class="hv-erweiterungen-section">
  <div *ngIf="!showProduktBuendel; else produktBuendelTemplate">
    <div *ngIf="showProduktEigenheim; else infotextHaushalt">
      <p class="smallprint-gray">Die HDI Eigenheimversicherung inkludiert eine Gebäude- und Grundstückshaftpflicht mit einer Versicherungssumme von € 2,5 Mio.</p>
    </div>
    <ng-template #infotextHaushalt>
      <div><p class="smallprint-gray">Die HDI Haushaltsversicherung inkludiert eine Privathaftpflicht-Versicherung mit einer Versicherungssumme von € 2,5 Mio.</p></div>
    </ng-template>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="erhoehungVersicherungssummeHaushaltTemplate"></ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="erhoehungVersicherungssummeEigenheimTemplate"></ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="haftpflichtWeiterePersonenTemplate"></ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="haftpflichtHundeTemplate"></ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="sicherheitsEingangstuerTemplate"></ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="alarmanlageTemplate"></ng-template>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <app-aufbewahrung-wertsachen [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="aufbewahrungWertsachen" [showGroup]="showProduktHaushalt" (calculateRatePendingEvent)="onCalculateRatePending()"></app-aufbewahrung-wertsachen>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <ng-template *ngTemplateOutlet="selbstbehaltTemplate"></ng-template>
      </div>
    </div>
  </div>
  <ng-template #produktBuendelTemplate>
    <div class="mt-3">
      <h6>Haushalt & Eigenheim</h6>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="haftpflichtHundeTemplate"></ng-template>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <h6>Eigenheim</h6>
      <div><p class="smallprint-gray">Die HDI Eigenheimversicherung inkludiert eine Gebäude- und Grundstückshaftpflicht mit einer Versicherungssumme von € 2,5 Mio.</p></div>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="erhoehungVersicherungssummeEigenheimTemplate"></ng-template>
        </div>
      </div>
    </div>
    <div class="mt-3">
      <h6>Haushalt</h6>
      <div><p class="smallprint-gray">Die HDI Haushaltsversicherung inkludiert eine Privathaftpflicht-Versicherung mit einer Versicherungssumme von € 2,5 Mio.</p></div>
      <div class="row">
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="erhoehungVersicherungssummeHaushaltTemplate"></ng-template>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="haftpflichtWeiterePersonenTemplate"></ng-template>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="sicherheitsEingangstuerTemplate"></ng-template>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="alarmanlageTemplate"></ng-template>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <app-aufbewahrung-wertsachen [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="aufbewahrungWertsachen" [showGroup]="showProduktHaushalt" (calculateRatePendingEvent)="onCalculateRatePending()"></app-aufbewahrung-wertsachen>
        </div>
        <div class="col col-xs-12 col-sm-12">
          <ng-template *ngTemplateOutlet="selbstbehaltTemplate"></ng-template>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #haftpflichtHundeTemplate>
          <div class="input_radio">
            <app-label [control]="haftpflichtHunde" for="haftpflichtHunde">Hundehaftpflicht</app-label>
            <mat-radio-group id="haftpflichtHunde" formControlName="haftpflichtHunde">
              <mat-radio-button value="ja">Ja</mat-radio-button>
              <mat-radio-button value="nein">Nein</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="haftpflichtHunde.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
    <div *ngIf="showHaftpflichtAnzahlHunde">
      <app-label [control]="haftpflichtAnzahlHunde" for="haftpflichtAnzahlHunde">Anzahl Hunde:</app-label>
      <mat-form-field class="hv-erweiterungen-anzahl-select hv-erweiterungen-anzahl-hunde-select">
      <mat-select id="haftpflichtAnzahlHunde" formControlName="haftpflichtAnzahlHunde">
        <mat-option [value]="1">1</mat-option>
        <mat-option [value]="2">2</mat-option>
        <mat-option [value]="3">3</mat-option>
      </mat-select>
      </mat-form-field>
      <mat-error *ngIf="haftpflichtAnzahlHunde.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
  <ng-template #erhoehungVersicherungssummeHaushaltTemplate>
    <div class="input_radio" *ngIf="showErhoehungVersicherungssummeHaushalt">
      <app-label [control]="erhoehungVersicherungssummeHaushalt" for="erhoehungVersicherungssummeHaushalt">Versicherungssumme auf € 5 Mio. erhöhen</app-label>
      <mat-radio-group id="erhoehungVersicherungssumme" formControlName="erhoehungVersicherungssummeHaushalt">
        <mat-radio-button value="ja">Ja</mat-radio-button>
        <mat-radio-button value="nein">Nein</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="erhoehungVersicherungssummeHaushalt.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
  <ng-template #erhoehungVersicherungssummeEigenheimTemplate>
    <div class="input_radio" *ngIf="showErhoehungVersicherungssummeEigenheim">
      <app-label [control]="erhoehungVersicherungssummeEigenheim" for="erhoehungVersicherungssummeEigenheim">Versicherungssumme auf € 5 Mio. erhöhen</app-label>
      <mat-radio-group id="erhoehungVersicherungssumme" formControlName="erhoehungVersicherungssummeEigenheim">
        <mat-radio-button value="ja">Ja</mat-radio-button>
        <mat-radio-button value="nein">Nein</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="erhoehungVersicherungssummeEigenheim.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
  <ng-template #haftpflichtWeiterePersonenTemplate>
    <div class="row">
      <div class="col col-xs-12 col-sm-12">
        <div class="input_radio" *ngIf="showProduktHaushalt">
          <div class="text_info">
            <app-label [control]="haftpflichtWeiterePersonen" for="haftpflichtWeiterePersonen">Weitere Personen in der Privathaftpflicht für die gewählte Versicherungssumme hinzufügen</app-label>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('HVHAFTPFLICHTWEITEREPERSONENINFO') | async) as res" (click)="popupService.openInfoPopup(res)">
              </div>
            </div>
          </div>
          <mat-radio-group id="haftpflichtWeiterePersonen" formControlName="haftpflichtWeiterePersonen">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="haftpflichtWeiterePersonen.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
      <div class="col col-xs-12 col-sm-12">
        <div *ngIf="showHaftpflichtAnzahlWeiterePersonen">
          <app-label [control]="haftpflichtAnzahlWeiterePersonen" for="haftpflichtAnzahlWeiterePersonen">Anzahl Personen:</app-label>
          <mat-form-field class="hv-erweiterungen-anzahl-select hv-erweiterungen-anzahl-personen-select">
            <mat-select id="haftpflichtAnzahlWeiterePersonen" formControlName="haftpflichtAnzahlWeiterePersonen">
              <mat-option [value]="1">1</mat-option>
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="3">3</mat-option>
              <mat-option [value]="4">4</mat-option>
              <mat-option [value]="5">5</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error *ngIf="haftpflichtAnzahlWeiterePersonen.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #sicherheitsEingangstuerTemplate>
    <div class="input_radio" *ngIf="showProduktHaushalt">
      <div class="text_info">
        <app-label [control]="sicherheitsEingangstuer" for="sicherheitsEingangstuer">Sicherheitseingangstür gemäß ÖNORM B5338</app-label>
        <div class="info">
          <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('HVSICHERHEITSTUERINFO') | async) as res" (click)="popupService.openInfoPopup(res)">
          </div>
        </div>
      </div>
      <mat-radio-group id="sicherheitsEingangstuer" formControlName="sicherheitsEingangstuer">
        <mat-radio-button value="ja">Ja</mat-radio-button>
        <mat-radio-button value="nein">Nein</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="sicherheitsEingangstuer.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
  <ng-template #alarmanlageTemplate>
    <div class="input_radio" *ngIf="showProduktHaushalt">
      <div class="text_info">
        <app-label [control]="alarmanlage" for="alarmanlage">VSÖ-geprüfte Alarmanlage</app-label>
        <div class="info">
          <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('HVALARMANLAGEINFO') | async) as res" (click)="popupService.openInfoPopup(res)">
          </div>
        </div>
      </div>
      <mat-radio-group id="alarmanlage" formControlName="alarmanlage">
        <mat-radio-button value="ja">Ja</mat-radio-button>
        <mat-radio-button value="nein">Nein</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="alarmanlage.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
  <ng-template #selbstbehaltTemplate>
    <div class="input_radio" *ngIf="showProduktHaushalt">
      <div class="text_info">
        <app-label [control]="selbstbehalt" for="selbstbehalt">Selbstbehalt von € 150,- im Schadensfall</app-label>
        <div class="info">
          <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('HVSELBSTBEHALTINFO') | async) as res" (click)="popupService.openInfoPopup(res)">
          </div>
        </div>
      </div>
      <mat-radio-group id="selbstbehalt" formControlName="selbstbehalt">
        <mat-radio-button value="ja">Ja</mat-radio-button>
        <mat-radio-button value="nein">Nein</mat-radio-button>
      </mat-radio-group>
      <mat-error *ngIf="selbstbehalt.hasError('required') && parentFormGroupDirective.submitted">{{ 'SELECTREQUIRED' | translate }}</mat-error>
    </div>
  </ng-template>
</form>
